import axios from 'axios';
import apiConfig from '../api.config';

export default function updatePoliceSFTP({
  hotelId,
  bookingProvider,
  ftpConfig,
  fileFormat,
  filePrefix,
  fileSufix,
  ftpDirPath,
  type,
}) {
  const {
    host,
    URIs: { policeReport, policeReportSFTP },
  } = apiConfig;

  const uri = `${host}${policeReport}/${policeReportSFTP.replace(':hotelId', hotelId)}`;

  return axios
    .put(
      uri,
      JSON.stringify({
        ftpConfig,
        fileFormat,
        ftpDirPath,
        filePrefix,
        fileSufix,
        bookingProvider,
        type,
      }),
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    .then(res => {
      return res.data;
    });
}
